// extracted by mini-css-extract-plugin
export default {"page-pagination":"g5koF","page-pagination__item":"ndIGG","page-pagination__separator":"pZYeL"};